/**
 * This value is used in the client code to complete the instrumentation for one of the performance metrics.
 *
 * It is then used in a performance test to exercise that instrumentation.
 */
export const TablePerformanceTestUtils = {
  expectedCellValue: 'SYNTHETIC_TEST_VALUE',
};
